// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/eventdetails.less
// module id = 407
// module chunks = 0